import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Modal from "../../../../components/Common/Modal/Modal";
import { mode } from "../../../../utils/formModes";
import CreatePollForm from "../CreatePoll/CreatePollForm";
import classes from "./CopyPollModal.module.scss";

const CopyPollModal = ({
  isCopyModal,
  setisCopyModal,
  pollId,
  handleSearchQuery,
}) => {
  const socialState = useSelector((state) => state.socialReducer);
  const { copyPollResponseData } = socialState;

  useEffect(() => {
    if (copyPollResponseData) {
      setisCopyModal(false);
      handleSearchQuery();
    }
  }, [copyPollResponseData, setisCopyModal, handleSearchQuery]);

  return (
    <Modal
      isOpen={isCopyModal}
      heading={"Copy Poll"}
      toggle={() => setisCopyModal(false)}
      width={"110"}
    >
      <div className={classes.copyPoll}>
        <CreatePollForm
          formMode={mode.COPY}
          pollId={pollId}
          setisCopyModal={setisCopyModal}
        />
      </div>
    </Modal>
  );
};

export default CopyPollModal;
